import { Path } from 'react-hook-form'

import {
  BookingLeadChannel,
  BookingLeadViewStatus,
  DiscountKind,
} from '@avantstay/arriere-clients/dist/arriereBackoffice'

import { HomeDataForQuoteProps, HomeSimpleDataForQuote } from '@arriere/types/BookingPrices.types'

export interface BookingQuoteContactInput {
  fullName: string
  email: string
  phone?: string
  guestId?: string
}

export interface DiscountInput {
  discountKind: DiscountKind
  discountAmount: number
}

export enum EmailType {
  QUOTE_WITH_PRICE = 'QUOTE_WITH_PRICE',
  QUOTE_WITH_PRICE_WITHOUT_TAXES = 'QUOTE_WITH_PRICE_WITHOUT_TAXES',
  WITHOUT_BRANDING_AND_PRICE = 'WITHOUT_BRANDING_AND_PRICE',
  QUOTE_WITHOUT_PRICE = 'QUOTE_WITHOUT_PRICE',
}

export type HomeSleepingPlaces = HomeSimpleDataForQuote['rooms'][0]['sleepingPlaces']

export interface HomesForQuotes extends Omit<Partial<HomeDataForQuoteProps>, 'id'> {
  id: string
  isHomeSelected?: boolean
  quotePrice?: number
  quotePriceBeforeTaxes?: number
  maxStay?: number
  minStay?: number
  discount?: DiscountInput
  // maxDiscount represents the sum of all floor prices
  maxDiscount?: number
  shortDescription?: string
  longDescription?: string
}

export interface CreateQuoteFormProps {
  checkIn?: string
  checkOut?: string
  salesFrom?: string
  salesTo?: string
  guests: number
  pets: number
  contact?: BookingQuoteContactInput
  homes?: HomesForQuotes[]
  emailType: EmailType
  phone?: string
  status?: BookingLeadViewStatus
  regionIds?: string[]
  homesInterested?: string[]
  channel?: BookingLeadChannel
  datesInterested?: string
  additionalNotes?: string
  needsFollowUp?: boolean
}

export type FieldPath = Path<CreateQuoteFormProps>

export enum QuotesFormView {
  formContent = 'FORM_CONTENT',
  emailPreview = 'EMAIL_PREVIEW',
}
